const FilterOperator = {
    Empty: "",
    IsTrue: "IS TRUE",
    IsFalse: "IS FALSE",
    IsNotTrue: "IS NOT TRUE",
    IsNotFalse: "IS NOT FALSE",
    Equals: "=",
    NotEquals: "!=",
    IsNull: "IS NULL",
    IsNotNull: "IS NOT NULL",
    Is: "IS",
    In: "IN",
    NotIn: "NOT IN",
    IsNot: "IS NOT",
    LessThan: "<",
    LessThanOrEquals: "<=",
    GreaterThan: ">",
    GreaterThanOrEquals: ">=",
    Between: "BETWEEN",
    NotBetween: "NOT BETWEEN",
    BetweenBeforeNow: "BETWEEN BEFORE NOW",
    Contains: "CONTAINS",
    ContainsCaseInsensitive: "CONTAINS CASE INSENSITIVE",
    NotContains: "NOT CONTAINS",
    NotContainsCaseInsensitive: "NOT CONTAINS CASE INSENSITIVE",
    StartsWith: "STARTS WITH",
    StartsWithCaseInsensitive: "STARTS WITH CASE INSENSITIVE",
    NotStartsWith: "NOT STARTS WITH",
    NotStartsWithCaseInsensitive: "NOT STARTS WITH CASE INSENSITIVE",
    EndsWith: "ENDS WITH",
    EndsWithCaseInsensitive: "ENDS WITH CASE INSENSITIVE",
    NotEndsWith: "NOT ENDS WITH",
    NotEndsWithCaseInsensitive: "NOT ENDS WITH CASE INSENSITIVE",
    Like: "LIKE",
    LikeCaseInsensitive: "LIKE CASE INSENSITIVE",
    NotLikeCaseInsensitive: "NOT LIKE CASE INSENSITIVE",
    NotLike: "NOT LIKE"
};

export { FilterOperator };
//# sourceMappingURL=types.js.map
